import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import { IPVerificationStatus } from "src/model/enum/server-ip-verification";

export class Plant {
  public ID: number = 0;
  public PlantName: string = "";

  /**
   * Operative mode in which the app shall work while logged-in to the peculiar plant.
   */
  public operativeMode: BIGDeviceOperationMode =
    BIGDeviceOperationMode.STANDARD;

  public LANHttps: boolean = false;
  public LANAddress: string = "";
  public LanPort: string = "";

  public WANHttps: boolean = false;
  public WANAddress: string = "";
  public WanPort: string = "";

  public Username: string = "";
  public Password: string = "";

  public LANIPVerified: number = IPVerificationStatus.WAIT_TO_CHECK;
  public WANIPVerified: number = IPVerificationStatus.WAIT_TO_CHECK;

  /**
   *
   */
  public AllowWanConnection: boolean = true;

  /**
   * Flag value; if the "Remember Credentials" function OR "AutoLogin" function is toggled on in the "login-access-plant", then it is set to TRUE; otherewise, it is set FALSE.
   *
   * DEFAULT: true.
   */
  public RememberMe: boolean = true;

  public Endpoint: string = "";
  public SocketPort: string = "";
  public LANMqttPort: string = "";
  public WANMqttPort: string = "";

  public defaultSupervision: string = "-1,0";

  /**
   * Flag value; if the changes to the plant's attributes must NOT be reacted to in the single pages/services, it is set to TRUE; othervise, it is set to FALSE.
   */
  public changesBlocked: boolean = false;

  /**
   * Flag value; if the changes to the plant's attributes must NOT be reacted to BY THE "attachMobileNetworkEvent" ON MOBILE DEVICES, in the single pages/services, it is set to TRUE; othervise, it is set to FALSE.
   */
  //public mobileChangesBlocked: boolean = false;

  /**
   * Flag value; if the "auto-login" function is toggled on in the "login-access-plant", then it is set to TRUE; otherewise, it is set FALSE.
   */
  public isAutoLoginOn: boolean = false;

  get FullLanAddress() {
    return (
      this.getProtocolAsString(this.LANHttps) +
      "://" +
      this.LANAddress +
      ":" +
      this.LanPort
    );
  }

  get FullWanAddress() {
    return (
      this.getProtocolAsString(this.WANHttps) +
      "://" +
      this.WANAddress +
      ":" +
      this.WanPort
    );
  }

  /**
   * Getter to check if Wan Address if filled
   */
  get isWanFieldFilled() {
    return (
      this.WANAddress !== "" && this.WANMqttPort !== "" && this.WanPort !== ""
    );
  }

  private getProtocolAsString(isHttpsProtocol: boolean) {
    return isHttpsProtocol ? "https" : "http";
  }

  constructor(plantType?: any) {
    // used for assign type to instance of object
    if (plantType) {
      Object.assign(this, plantType);
    }
  }
}
